<script setup lang="ts">
import { useFormatDate } from '../composables/formatDate'
import { useFormatTime } from '../composables/formatTime'
import { useQuasar } from 'quasar'
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useUserStore } from '../store/useUserStore'
import { useI18n } from 'vue-i18n'

const { t } = useI18n({ useScope: 'global' })
const timelineLabel = (key: string) => t(`timeline.${key}`)
const payPeriod = (key: string) => t(`payPeriod.${key}`)

//ripple stuff
const $q = useQuasar()
defineExpose({ $q })

const props = defineProps<{
  time: number
  toBePaidDistance: number
  toBePaidHours: number
  expenses: number
  orders: number
  status: 'accepted' | 'declined' | 'processing' | 'incomplete'
  date: string
  fixBy?: Date
  editedCount?: number
  /**The time in central it was updated on portal */
  lastUpdatedAt?: string
}>()

const dateText = computed(() => {
  const formattedDate = useFormatDate(new Date(props.date), { language_choice: user.language })
  return `${formattedDate.weekday()}, ${formattedDate.month()} ${formattedDate.day()}`
})
const timeText = computed(() => {
  return useFormatTime(props.time, { format: 'h:mm', initTime: 'minutes' })
})
const expensesText = computed(() => {
  return props.expenses.toLocaleString(undefined, { style: 'currency', currency: 'USD' })
})
const fixByDate = computed(() => {
  if (!props.fixBy) return ''
  const formattedDate = useFormatDate(props.fixBy, { language_choice: user.language })
  return `${formattedDate.weekday()}, ${formattedDate.month()} ${formattedDate.day()}`
})

const user = storeToRefs(useUserStore())
</script>
<template>
  <q-item to="/home-denied1" clickable v-ripple>
    <q-item-section>
      <q-item-label class="text-h6 text-weight-regular text-black">
        {{ dateText }}
      </q-item-label>
      <q-item-label caption lines="2">
        <strong class="text-grey-9">{{ timeText }}</strong> {{ payPeriod('time') }} •
        <strong class="text-grey-9">{{ toBePaidDistance }}</strong>
        {{ timelineLabel(user.distance.value) }} •
        <strong class="text-grey-9">{{ expensesText }}</strong> {{ payPeriod('expenses') }} •
        <strong class="text-grey-9">{{ orders }}</strong> {{ payPeriod('orderItems') }}
      </q-item-label>
      <q-item-label caption lines="1">
        <template v-if="editedCount">
          <strong class="text-grey-9">{{ editedCount }}</strong> {{ payPeriod('edits') }}
        </template>
        <template v-if="lastUpdatedAt">
          •
          <strong class="text-grey-9">
            {{
              useFormatDate(new Date(lastUpdatedAt), { language_choice: user.language }).month({
                month: 'short',
              })
            }}
            {{ useFormatDate(new Date(lastUpdatedAt), { language_choice: user.language }).day() }}
            {{ useFormatDate(new Date(lastUpdatedAt + ' CDT')).time() }}
          </strong>
          {{ payPeriod('lastUpdated') }}
        </template>
      </q-item-label>
    </q-item-section>
    <q-item-section side top>
      <!-- <q-badge color="primary" label="Today" /> -->
      <q-badge v-if="status === 'approved'" color="positive" :label="payPeriod('accepted')" />
      <template v-else-if="status === 'declined'">
        <q-badge color="negative" :label="payPeriod('declined')" />
        <q-item-label caption class="q-mt-xs text-negative">
          <strong> {{ payPeriod('fixBy') }} {{ fixByDate }}</strong>
        </q-item-label>
      </template>
      <template v-else-if="status === 'incomplete'">
        <q-badge color="negative" :label="payPeriod('incomplete')" />
        <q-item-label caption class="q-mt-xs text-negative">
          <strong> {{ payPeriod('fixBy') }} {{ fixByDate }}</strong>
        </q-item-label>
      </template>
      <q-badge v-else color="grey" :label="payPeriod('processing')" />
    </q-item-section>
  </q-item>
</template>
